import { CircularProgress } from '@andritzot/metris-web-ui/feedback/progress/circular-progress';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

interface BusyContextProps {
  isLoading: boolean;
}

const BusyContext = ({ isLoading }: BusyContextProps) => {
  if (!isLoading) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default BusyContext;
